// messageService.js
import { ref } from 'vue'

const messageState = ref({
    show: false,
    message: '',
    level: 'info'
})

let timeoutId = null

export const useMessage = () => {
    const show = (message, level = 'info', duration = 0) => {
        messageState.value = {
            show: true,
            message,
            level
        }
        
        if (timeoutId) clearTimeout(timeoutId)
        if(duration!=0)timeoutId = setTimeout(hide, duration)
    }

    const hide = () => {
        messageState.value.show = false
    }

    return {
        messageState,
        show,
        hide,
        info: (msg, duration) => show(msg, 'info', duration),
        success: (msg, duration) => show(msg, 'success', duration),
        warning: (msg, duration) => show(msg, 'warning', duration),
        error: (msg, duration) => show(msg, 'danger', duration)
    }
}